import { Alignment, HorizontalPadding, TopPadding } from '@easeltv/client-sdk';
import styled from 'styled-components';

import { interpretFooterSpacing } from '../../../utilities';
import { P } from '../../typography';

export const StyledFooterText = styled(P)`
    padding: 0;
    margin: 0;
    line-height: 1.3;
    max-width: 40rem;
    display: inline-block;
    width: 100%;
    font-size: 0.9em;
`;

export const StyledFooterTextBlock = styled.div<{
    alignment: Alignment;
    topPadding: TopPadding;
    horizontalPadding: HorizontalPadding;
}>(
    ({ alignment, topPadding, horizontalPadding }) => `
        text-align: ${alignment};

        ${StyledFooterText}{
            text-align: ${alignment};
            padding-top: ${interpretFooterSpacing(topPadding)};
            padding-left: ${interpretFooterSpacing(horizontalPadding)};
            padding-right: ${interpretFooterSpacing(horizontalPadding)};
        }
    `,
);
